export const StandardColumnWidths = {
  address1: "350px",
  address2: "200px",
  city: "200px",
  countyName: "155px",
  dateDeactivated: "200px",
  npi: "120px",
  npiType: "110px",
  providerName: "350px",
  specialtyCode: "160px",
  specialtyName: "250px",
  zip: "90px",
};
